<ng-template #loading>
  <terra-loader></terra-loader>
</ng-template>

<ng-container *ngIf="fund$ | async as fund else loading">
  <!-- When the fund is private -->
<!--  <div *ngIf="fund.isPrivate" class="private-asset">
    <p class="private-asset-title"><span class="lo_sensitive">{{ fund.gpDetails.agentCompanyName }}</span> <br>
      has temporarily removed fund <span class="lo_sensitive">{{ fund.name }}</span></p>
    <p class="private-asset-extra">We will notify you as soon as the fund is re-published.</p>
  </div>-->

  <!-- Mobile back button -->
<!--  <button class="back-button" mat-icon-button [ngClass]="{'inverse-color': fund.isPrivate}">-->
<!--    <mat-icon [routerLink]="backUrl(originFundId$ | async)" class="notranslate">keyboard_arrow_left</mat-icon>-->
<!--  </button>-->

<!--  <ng-container *ngIf="!fund.isPrivate">-->
    <terra-private-holding-notification [holding]="fund"></terra-private-holding-notification>
    <div class="breadcrumbs container" *ngIf="fund">
      <a [routerLink]="holdingsPageUrl">Portfolio > </a>
      <ng-container *ngIf="originFundBasicInfo$ | async as originFund">
        <a *ngIf="originFund" [routerLink]="getFundPageUrl(originFund.id)">
          {{originFund.name}} > </a>
      </ng-container>
      <span class="lo_sensitive current"> {{ fund.name }}</span>
    </div>

    <terra-holding-general-information [holding]="fund$ | async" [holdingDiscriminator]="HoldingDiscriminator.Fund"></terra-holding-general-information>

    <section class="basic-details">
      <a *ngIf="opportunityCode !== null && opportunityCode !== undefined" class="proceed-with-opportunity-button"
         mat-flat-button [routerLink]="getMarketingDeckPage()" [queryParams]="{isRegistered: 'True'}">
        Get additional information
      </a>
    </section>

    <!-- TABS -->
    <terra-lp-holding-tabs-nav class="nav-bar" [isFunded$]="isFunded$" [originFundId$]="originFundId$" [tabPanel]="tabPanel" />
    <!-- Tabs content  -->
    <mat-tab-nav-panel #tabPanel>
      <router-outlet />
    </mat-tab-nav-panel>

    <!-- <div class="remove-example-section" *ngIf="fund.id === EXAMPLE_ASSET_ID">
      <button type="button" (click)="removeExampleAsset()" mat-flat-button color="warn" class="remove-example-button">Remove this
        example</button>
    </div> -->

    <!-- <a *ngIf="fund.email" class="link contact-gp" href="mailto:{{ fund.email }}" target="_blank">Contact
      <span class="lo_sensitive">{{ fund.gpDetails?.agentCompanyName }}</span>
    </a> -->
  </ng-container>
<!--</ng-container>-->
